import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "timeAgo",
    standalone: false,
})
export class TimeAgoPipe implements PipeTransform {
    transform(value: string | number | Date | null | undefined): string {
        if (!value) {
            return "";
        }

        const date = new Date(value);
        const seconds = Math.floor((Date.now() - date.getTime()) / 1000);

        if (seconds < 60) return `${seconds}s ago`;
        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) return `${minutes}m ago`;
        const hours = Math.floor(minutes / 60);
        if (hours < 24) return `${hours}h ago`;
        const days = Math.floor(hours / 24);
        return `${days}d ago`;
    }
}
